import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const ApplyButton = () => {
  const [showModal, setShowModal] = useState(false);
  return <>
      <div className="flex justify-center" data-id="element-38">
        <div className="relative" data-id="element-39">
          <div className="button-border-light" data-id="element-40"></div>
          <motion.button onClick={() => setShowModal(true)} whileHover={{
          scale: 1.05,
          boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
        }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-8 sm:px-10 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-41">
            Apply for the MRI Now
          </motion.button>
        </div>
      </div>

      {/* Capacity Full Modal */}
      <AnimatePresence data-id="element-42">
        {showModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90" onClick={() => setShowModal(false)} data-id="element-43">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="relative w-full max-w-lg bg-gradient-to-b from-[#111111] to-[#0a0a0a] border border-[#ffdf07]/30 rounded-lg shadow-2xl p-8" onClick={e => e.stopPropagation()} data-id="element-44">
              <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-45">
                <XIcon size={24} data-id="element-46" />
              </button>

              <div className="text-center" data-id="element-47">
                <h2 className="typekit-heading text-2xl sm:text-3xl text-[#ffdf07] mb-4" data-id="element-48">
                  Capacity Completely Full
                </h2>
                <p className="libre-caslon-text-regular text-gray-300 text-base sm:text-lg leading-relaxed mb-6" data-id="element-49">
                  We are no longer accepting applications at this time as our
                  capacity is completely full.
                </p>
                <p className="libre-caslon-text-regular text-gray-300 text-base leading-relaxed mb-6" data-id="element-50">
                  If you'd like to be notified when spots become available,
                  please send an email to:
                </p>
                <a href="mailto:ivan@516partners.com" className="inline-block bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-6 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] hover:scale-105 transition-transform duration-300" data-id="element-51">
                  ivan@516partners.com
                </a>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};
export default ApplyButton;